import { Transition } from '@headlessui/react'
import { ReactNode } from 'react'

export function ColorPickerContainer({
  showControls,
  children,
}: {
  showControls: boolean
  children: ReactNode
}) {
  return (
    <Transition
      show={showControls}
      enter="transition-translate duration-[200ms] ease-linear"
      enterFrom="-translate-x-full"
      enterTo="translate-x-0 h-full"
      leave="transition-translate duration-[200ms] ease-linear"
      leaveFrom="translate-x-0 h-full"
      leaveTo="-translate-x-full"
    >
      <div
        className="hidden absolute top-0 bottom-0 sm:flex flex-col w-7/12 border-r-2 border-solid bg-white rounded-l-[16px] border-acai-5 max-w-[300px]"
        onClick={(event) => {
          event.stopPropagation()
        }}
      >
        {children}
      </div>
    </Transition>
  )
}
